import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import useGoTo from '../../../utilities/useGoTo';
import BankList from './BankList';

const BankListPage = () => {
    const { t } = useTranslation('bankList');

    const goToNewBankPage = useGoTo('/admin/banks/add');
    const { permissions: accountPermissions } = useAccount();

    const extra = hasPermissions(accountPermissions, [permissionKind.createBank]) && (
        <Button icon={<PlusOutlined />} onClick={goToNewBankPage} type="primary">
            {t('bankList:actions.newBank')}
        </Button>
    );

    return (
        <ConsolePageWithHeader extra={extra} title={t('bankList:title')}>
            <BankList />
        </ConsolePageWithHeader>
    );
};

export default BankListPage;
